import React, { useMemo } from 'react'

import { Button, Column, Text } from 'Components/UI'
import { DateTime } from 'luxon'
import { EventItem } from 'Types/emajinAPI'
import Utils from 'Utils'

import { Container, ImageHolder, StyledButton } from './styles'
import TextRow, { EventsListGalleryCardTextRowKind } from './TextRow'

type Props = {
  data?: EventItem
  onReadMore?: () => void
  onRSVP?: () => void
}

function EventsListGalleryCard({ data, onReadMore, onRSVP }: Props) {
  const attachedImages = useMemo(
    () => Utils.Attachment.getAcceptableAttachment(data?.attachments),
    [data],
  )

  if (!data) return null

  return (
    <Container
      flexDirection={['column', 'column', 'column', 'row']}
      maxHeight={['unset', 'unset', 'unset', 300]}
    >
      <ImageHolder>
        {attachedImages?.length && <img alt="" src={attachedImages[0].url} />}
      </ImageHolder>

      <Column fullWidth gap={3} px={[4, 4, 4, 0]} py={[4, 4, 4, 5]}>
        {data.date && (
          <TextRow
            kind={EventsListGalleryCardTextRowKind.Date}
            text={DateTime.fromISO(data.date).toFormat('dd MMMM yyyy')}
          />
        )}

        {data.name && (
          <TextRow
            kind={EventsListGalleryCardTextRowKind.Name}
            text={`${data.name}${data.location ? `, ${data.location}` : ''}`}
          />
        )}

        {data.presenterName && (
          <TextRow
            kind={EventsListGalleryCardTextRowKind.Presenter}
            text={`${data.presenterName}${
              data.presenterJobTitle ? `, ${data.presenterJobTitle}` : ''
            }`}
          />
        )}

        <TextRow
          kind={EventsListGalleryCardTextRowKind.Address}
          text={data.address ?? ''}
        />
      </Column>

      <Column
        alignCenter
        gap={[8, 8, 6]}
        pb={[5, 5, 8]}
        pt={[0, 0, 8]}
        width={[1, 1, 1 / 2]}
      >
        <Button large minWidth={120} onClick={onRSVP}>
          RSVP
        </Button>

        <StyledButton onClick={onReadMore}>
          <Text medium screen16>
            Learn more
          </Text>
        </StyledButton>
      </Column>
    </Container>
  )
}

export default EventsListGalleryCard
